import createResourceSelectors from 'store/utils/createResourceSelectors'

export default createResourceSelectors('alerts', {
  getUnreadAlertsCount: state => state.resources.alerts.unread
})
